import type { ErrorResponse2ErrorDetails } from './errorResponse2ErrorDetails';

/**
 * 에러 응답 형식
 */
export interface ErrorResponse2 {
  /** 에러 코드 */
  errorCode?: string;
  /**
   * 상세 에러 정보
   * @nullable
   */
  errorDetails?: ErrorResponse2ErrorDetails;
  /** 에러 메시지 */
  message: string;
  /** 요청 성공 여부 */
  success: boolean;
  /** 에러 발생 시간 */
  timestamp?: string;
}
